export class UserLogin {
	Username!: string;
	Password!: string;
}
